import { PropsWithChildren, createContext, useContext } from "react";

import { Currency } from "currency";

import { ImageStorageProps } from "../../../components/ImageUpload";
import { MerchantPricing } from "../types";

// props passed directly through context, without modifying,
// must be passed via ProductForm feature
type PassthroughProps = ImageStorageProps & {
  isCloningProduct: boolean;
  deleteProduct: () => Promise<void>;
  goBack: () => void;
};

// all props passed through + some others necessary
type ContextType = PassthroughProps & {
  currency: Currency;
  merchantPricing: MerchantPricing;
};

const Context = createContext<ContextType | null>(null);

export type { PassthroughProps as TProductFormAPIProps };

export default function useProductFormAPI() {
  const ctx = useContext(Context);
  if (!ctx) throw new Error("Missing ProductFormContextProvider");
  return ctx;
}

export function ProductFormAPIProvider({
  children,
  ...props
}: PropsWithChildren<ContextType>) {
  return <Context.Provider value={props}>{children}</Context.Provider>;
}
